import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import ResourceSelector from '../../components/ResourceSelector';

interface ResourceSelectorContainerProps {
	id: string;
}

const mapStateToProps = (state: StoreState, ownProps: ResourceSelectorContainerProps) => {
	const item = state.importManager.byId[ownProps.id];

	return {
		isImportingFile: !!item,
		importingPercentage: item ? item.percentage : 0,
		importingError: item && item.error,
		isProcessingVideo: item && item.isProcessing,
	};
};

export default connect(mapStateToProps)(ResourceSelector);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ResourceSelector/index.tsx